import styled from 'styled-components';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 450px;
  gap: 24px;
  padding: 32px 20px;
  border-radius: 16px;
  background: ${COLORS.white};
  .image-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .heading {
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 18px;
    line-height: 26px;
    color: ${COLORS.black};
  }
  .sub-heading {
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 16px;
    line-height: 22px;
    color: ${COLORS.black};
  }
  .description {
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 16px;
    line-height: 22px;
    color: ${COLORS.black};
  }
  .list {
    list-style: disc;
    padding-left: 25px;
  }
  .btn-wrapper {
    width: 100%;
  }
  .message-info {
    margin-bottom: 24px;
  }
`;
export const Bold = styled.span`
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 16px;
  line-height: 22px;
`;
